import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationService } from 'app/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { CFCYChartComponent } from '../../components/NWMCharts/cfcychart.component';
import { CFRollingChartComponent } from '../../components/NWMCharts/cfrollingchart.component';

@Component({
    templateUrl: './CFCY-details.component.html',
    imports: [MenuComponent, CFCYChartComponent, CFRollingChartComponent]
})

export class CFCY_DetailsComponent implements OnInit {
  private auth = inject(AuthenticationService);
  private route = inject(ActivatedRoute);

  public plan = '';
  public isPershing = false;

  ngOnInit() {
    this.isPershing = this.auth.getCurrentReRg()!.IsPershing;
    this.route.params.subscribe(params => this.plan = params['id'] ? params['id'] : '');
  }
}
